import { createContext, useContext } from "react";

const DemoModeContext = createContext(false);

export function DemoModeProvider({ value = true, children }) {
  return <DemoModeContext.Provider value={value}>{children}</DemoModeContext.Provider>;
}

export function useDemoMode() {
  return useContext(DemoModeContext);
}
